const _excelReport = {
    mainExcel: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "AA",
        "AB",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AH",
        "AI",
        "AJ",
        "AK",
        "AL",
        "AM",
        "AN",
        "AO",
        "AP",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
    ],
    reportA: [
        {
            A: "Key ID",
            B: "MUICAA Member",
            C: "MUICAA Steering Committee",
            D: "Student_ID",
            E: "Academic Title_Eng",
            F: "Title_Eng",
            G: "English_First_Name",
            H: "English_Middle_Name",
            I: "English_Last_Name",
            J: "Thai_First_Name",
            K: "Thai_Middle_Name",
            L: "Thai_Last_Name",
            M: "Nationality",
            N: "Major",
            O: "Minor",
            P: "Concentration",
            Q: "Grade",
            R: "Graduate Status",
            S: "Graduate Year",
            T: "Graduate Date",
            U: "Address",
            V: "Home number",
            W: "Phone number",
            X: "Email",
            Y: "Facebook",
            Z: "IG",
        },
    ],
    reportB: [
        {
            A: "Key Profile ID",
            B: "Key Activity ID",
            C: "MUICAA Member",
            D: "MUICAA Steering Committee",
            E: "Student_ID",
            F: "Academic Title_Eng",
            G: "Title_Eng",
            H: "English_First_Name",
            I: "English_Middle_Name",
            J: "English_Last_Name",
            K: "Major",
            L: "Date of Activity",
            M: "Activity Name",
            N: "Role and Duty in the activity",
            O: "Organized By",
            P: "Graduate Year",
            Q: "Location",
            R: "Donation",
            S: "Budget",
            T: "Income",
            U: "Amount Charity",
            V: "Amount Fee",
            W: "Amount Sponsorship",
        },
    ],
    reportC: [
        {
            A: "Key Profile ID",
            B: "Key Award ID",
            C: "MUICAA Member",
            D: "MUICAA Steering Committee",
            E: "Student_ID",
            F: "Academic Title_Eng",
            G: "Title_Eng",
            H: "English_First_Name",
            I: "English_Middle_Name",
            J: "English_Last_Name",
            K: "Date of Recive",
            L: "Name of Award",
            M: "Place",
            N: "Organization",
            O: "Graduate Year",
            P: "Type of Award",
        },
    ],
    reportD: [
        {
            A: "Key ID",
            B: "Date of Activity",
            C: "Activity Name",
            D: "Organized By",
            E: "Location",
            F: "No. of Participants",
        },
    ],
    printFormatData: (val, type, subdetail) => {
        let result = ''
        if (typeof val !== "undefined" && val !== null) {
            if (type === 'Obj') {
                if (['academic_title_detail', 'title_name_detail'].includes(subdetail)) {
                    result = val[subdetail] !== null ? val[subdetail]['name_eng'] : ''
                } else {
                    result = val[subdetail] !== null ? val[subdetail] : ''
                }
            }
            else if (type === 'string') {
                result = !['', null, "null"].includes(val) ? val : ''
            }
            else if (type === 'array') { }
            else if (type === 'dateformat') { }
        }
        return result
    }
}
export default _excelReport;